const FLEXIBLE_DAYS = [1, 2, 3];

export { FLEXIBLE_DAYS }